<div class="container-fluid">
    <app-speed-dial-fab (clicked)="dispatch($event)" [options]="FabOptions"></app-speed-dial-fab>
    <!-- <button appPreventDoubleClick class="floating-button" mat-fab color="primary" (throttledClick)="addNewIntervention();">
        <mat-icon>add</mat-icon>
    </button> -->
    <div class="row mt-3">
        <div class="col-12 col-md-auto">
            <mat-form-field class="w-100">
                <mat-label>Date</mat-label>
                <input matInput [(ngModel)]="Date" [matDatepicker]="picker" placeholder="Date" (click)="picker.open()" >
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
        </div>

        <div class="col-12 col-md-auto">
            <mat-form-field class="w-100">
                <mat-label>Nom du client</mat-label>
                <input matInput [(ngModel)]="SearchText" placeholder="Nom du client"/>
            </mat-form-field>
        </div>
        <div class="col-12 col-md-auto">
            <button class="me-1" [class.h-75]="!coreData.IsMobile" appPreventDoubleClick mat-raised-button color="basic" (throttledClick)="clearFilter()" >
                Effacer
            </button>
            <button class="ms-1" [class.h-75]="!coreData.IsMobile" appPreventDoubleClick mat-raised-button color="primary" (throttledClick)="search()" >
                Rechercher
            </button>
        </div>

    </div>
    <div class="row justify-content-start mb-5">
        <div class="col-12 col-md-4 col-xl-2 my-2" *ngFor="let i of FilteredInterventionList">
            <div class="h-100 m-3">

                <div class="row border rounded-1 background-light h-100" [class.clickable]="i.Code !== undefined && i.Code !== ''" [class.no-opacity]="i.Code === undefined || i.Code === ''"
                     [style.border-bottom-color]="getBackgroundColorByInterventionStatus(i.Type)"
                     style="border-width: 2px !important; border-bottom: 10px solid !important;"
                     (click)="navigateToIntervention(i)">

                    <div class="d-flex flex-column col ms-1 p-2">
                        <div class="row">
                            <h2 class="col text-center fw-bold"> {{i.ELIMSData.StationName}}</h2>
                        </div>
                        <div class="row">
                            <h3 class="col text-center fw-bold"> {{i.ELIMSData.StationCode}}</h3>
                        </div>
                        <!-- <h5 class="card-header">{{i.ELIMSData.StationCode}}</h5> -->
                        <mat-chip-listbox class="m-auto my-3">
                            <mat-chip class="fw-bold" [style.background]="getBackgroundColorByInterventionStatus(i.Type)"
                                      [style.color]="getTextColorByInterventionStatus(i.Type)">{{getInterventionLabel(i)}}</mat-chip>
                            <mat-chip>{{i.PartnerCode}}</mat-chip>
                        </mat-chip-listbox>

                        <div class="row">
                            <span class="col text-center"> {{i.SampleCode}} </span>
                        </div>
                        <!-- <div class="row">
                            <span class="col text-center"> {{i.ELIMSData.StationCode}} </span>
                        </div> -->
                        <div class="row">
                            <span class="col text-center"> {{i.ELIMSData.ClientName}} </span>
                        </div>
                        <!-- <div class="row">
                            <span class="col text-center"> {{i.PartnerCode}} </span>
                        </div> -->
                        <!-- <div class="card-body">
                            <h4 class="card-title text-center fw-bold" [style.color]="getColorByInterventionStatus(i.Type)">{{getInterventionLabel(i)}}</h4>
                            <h5 class="card-title">{{i.SampleCode}}</h5>
                            <p class="card-text">{{i.ELIMSData.StationName}}</p>
                            <p class="card-text">{{i.ELIMSData.ClientName}}</p>
                            <p class="card-text">{{i.PartnerCode}}</p>
                        </div> -->

                        <div class="row d-flex align-items-center mt-auto g-0">
                            <span class="ps-3 col"><small class="text-muted">{{i.Date | date}}</small></span>

                            <span class="col-auto" *ngIf="IsOffline">

                                <button class="col-auto" appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="sync(i)" [disabled]="!hasLocalData(i) || loadingTask.IsLoading > 0">
                                    <mat-icon>refresh</mat-icon>
                                </button>

                                <button *ngIf="!hasLocalData(i)" class="col-auto" appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="warmup(i)"
                                        [disabled]="loadingTask.IsLoading > 0">
                                    <mat-icon>get_app</mat-icon>
                                </button>
                                <!-- <button *ngIf="hasLocalData(i)" appPreventDoubleClick mat-icon-button color="accent" (throttledClick)="openConfirmDialog(i)">
                            <mat-icon>get_app</mat-icon>
                        </button> -->
                            </span>
                            
                            <button *ngIf="!i.SampleCode" class="col-auto" appPreventDoubleClick mat-icon-button color="primary" (throttledClick)="openSampleCodeBox(i)" [disabled]="loadingTask.IsLoading > 0">
                                <mat-icon>app_registration</mat-icon>
                            </button>
                            <button class="col-auto" appPreventDoubleClick mat-icon-button color="warn" (throttledClick)="cancelIntervention(i)" [disabled]="loadingTask.IsLoading > 0">
                                <mat-icon>delete_outline</mat-icon>
                            </button>
                        </div>
                        <!-- <div style="height: 5px" [style.background]="getColorByInterventionStatus(i.Type)"></div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>